import { render, staticRenderFns } from "./peopleSkeleton.vue?vue&type=template&id=5e5a0eb0&scoped=true"
import script from "./peopleSkeleton.vue?vue&type=script&lang=js"
export * from "./peopleSkeleton.vue?vue&type=script&lang=js"
import style0 from "./peopleSkeleton.vue?vue&type=style&index=0&id=5e5a0eb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5a0eb0",
  null
  
)

export default component.exports